import { useState, useEffect } from "react";
function SummaryEditModal({ isVisible, setIsVisible, children }) {
  const display = isVisible ? "flex" : "none";

  const mediaMatch = window.matchMedia("(max-width: 500px");
  const [matches, setMatches] = useState(mediaMatch.matches);

  useEffect(() => {
    const handler = (e) => setMatches(e.matches);
    mediaMatch.addEventListener("change", handler);
    return () => mediaMatch.removeEventListener("change", handler);
  }, [matches]); // eslint-disable-line react-hooks/exhaustive-deps

  const Styles = {
    confirmBg: {
      position: "fixed",
      display: display,
      left: 0,
      top: 0,
      width: "100%",
      justifyContent: "center",
      minHeight: "100%",
      alignItems: "center",
      backgroundColor: "rgba(50, 50, 50, 0.3)",
      overflowY: "auto",
      zIndex: 101,
    },
    modal: {
      position: "absolute",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      borderRadius: 10,
      padding: matches ? "1rem" : "1rem 4rem 1.5rem",
      backgroundColor: "white",
      overflowY: "auto",
      maxHeight: matches ? "90%" : "80%",
      width: matches ? "90%" : "50vw",
    },
  };

  return (
    <div style={Styles.confirmBg} /*  onClick={closeEdit} */ className="editModal">
      <div style={Styles.modal} /* onClick={(e) => preventClick(e)} */>
        {children}
      </div>
    </div>
  );
}

export default SummaryEditModal;
